import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  onClick
}: CardProps) {
  return <motion.div whileHover={onClick ? {
    scale: 1.02
  } : undefined} whileTap={onClick ? {
    scale: 0.98
  } : undefined} onClick={onClick} className={`
        bg-white dark:bg-[#252936] 
        rounded-3xl p-6 
        shadow-sm border border-gray-100 dark:border-gray-800
        transition-colors duration-200
        ${className}
      `} data-id="element-166">
      {children}
    </motion.div>;
}